import Cookies from 'js-cookie'
import {setToken, getToken} from '@/mytools/util'
export var state = {

};

export var mutations = {

};



// WEBPACK FOOTER //
// ./src/store/mutations.js